(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class PivotCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.$tabs = this.querySelectorAll('.pvt-collection-tabs-menu .button');

      this.$tabs.forEach((button) => {
        console.log('Button', button);
        button.addEventListener('click', (e) => {
          const activeButton = this.querySelector('.pvt-collection-tabs-menu .button:not(.button-secondary)');
          if (activeButton === button) return;

          const activeSection = this.querySelector('.pvt-collection-tabs__section.is-active');
          const targetSection = this.querySelector(
            `.pvt-collection-tabs__section[data-block="${button.dataset.block}"]`
          );
          if (!targetSection) return;

          activeSection.classList.remove('is-active');
          activeButton.classList.add('button-secondary');

          // Buttons
          targetSection.classList.add('is-active');
          button.classList.remove('button-secondary');
        });
      });
    }
  }

  if (!customElements.get('pivot-collection-tabs')) {
    customElements.define('pivot-collection-tabs', PivotCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
